import { render } from "./Searching.vue?vue&type=template&id=b3c60832"
import script from "./Searching.vue?vue&type=script&lang=js"
export * from "./Searching.vue?vue&type=script&lang=js"

import "./Searching.vue?vue&type=style&index=0&id=b3c60832&lang=scss"
script.render = render

export default script